module.exports = __webpack_public_path__ + "0e5b2c4f2669955153135b60a2e35084.pdf";